import { Entity, EntityStringId, IEntityType, IIdentifiableEntity } from 'app/types/entity';
import vmClient from 'app/services/vmClient';
import { SiteFeature, SiteFeatureMarshaller } from 'app/constants/enums/SiteFeature';
import { Configuration, IConfiguration } from './Configuration';

export interface IBrandSiteFeature extends IIdentifiableEntity {
  attributes: {
    id: EntityStringId;
    siteFeature: SiteFeature;
    enabled: boolean;
  }
  associations: {
    configuration: IConfiguration | null;
  }
}

export type BrandSiteFeature = Entity<IBrandSiteFeature>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandSiteFeature: IEntityType<IBrandSiteFeature> = vmClient.defineClass({
  typeName: 'BrandSiteFeature',
  version: 1,
  persisted: true,
  attributes: {
    siteFeature: {
      type: SiteFeature,
      marshaller: SiteFeatureMarshaller,
      notNull: true,
    },
    enabled: {
      type: 'boolean',
      notNull: true,
    },
  },
  associations: {
    configuration: Configuration,
  },
});
